import ProfileGet from '../profile/index';
import ProfileSet from '../profile/set';
import {userService} from "../../../api";
import PbTokenGet from '../../../../pb/webauthauthpro.pb';
import sns from './sns/index';

const _system = Uplib.native.getSystem();
const feature = _system == 'pc' ? 9999 : 8888;
const deviceType = _system == 'pc' ? 'PC' : 'H5';
const version = _system == 'pc' ? '8.8.8' : '9.9.9';

const token = {
    // 获取up用户的usertoken
    get(platform, code, tokenSecret, verifier) {
        this.platform = platform;
        let channel = UpSDK.config.channel || '';

        let opt = {
            authcode: code,
            feature: feature + '',
            channel: channel.substr(0, 20),
            // language: UpSDK.config.language,
            deviceType,
            version,
        };

        switch (platform) {
            case 'wechat':
                opt.type = 3;
                break;
            case 'facebook':
                opt.type = 4;
                break;
            case 'twitter':
                opt.type = 16;
                opt = Object.assign(opt, {
                    tokenSecret,
                    verifier
                });
                break;
            case 'qq':
                opt.type = 2;
                opt.callback = encodeURIComponent(location.href);
                opt.state = 'test';
                break;
            case 'weibo':
                opt.type = 5;
                opt.callback = location.href;
                break;
            case 'line':
                opt.type = 19;
                // 外面传递的是就是state
                opt.state = tokenSecret;
                opt.callback = Uplib.url.delQuery(Uplib.url.delQuery(location.href, 'code'), 'state').replace(/#.*/, '');
                break;
            default:
                break;
        }

        if (window.smDeviceId) {
            opt.deviceId = window.smDeviceId;
        }

        userService('/webauth/auth/pro', PbTokenGet.WebAuth.AuthPro)(opt)
            .then((res) => {
                // subscribe - 是否关注up小助手
                // uid
                // userToken
                this.userData = res;
                typeof res.uid === 'object' ? res.uid = longToString(res.uid) : res.uid;

                UpSDK.writeLoginInfo(res);

                let getProfileCount = 0;
                let _getProfile = (uid) => {
                    let profile = new ProfileGet(uid);

                    profile.promise.done((data) => {
                        let countryCode = data.countryCode;

                        this.userData = Object.assign({}, this.userData, {
                            username: data.username,
                            avatar: data.avatar,
                            countryCode: data.countryCode,
                            gender: data.gender,
                            grade: data.grade,
                            upliveCode: data.upliveCode
                        });

                        if (!countryCode) {
                            this.setProfile(this.userData);
                        } else {
                            Uplib.loading.hide();
                            UpSDK.writeLoginInfo(this.userData);
                            this.back();
                        }
                    }).fail((data) => {
                        ++getProfileCount;

                        if (getProfileCount > 3) {
                            Uplib.loading.hide();
                            Uplib.notification.simple('Fail to get your personal information', 100 * 1000);
                        } else {
                            _getProfile(uid);
                        }
                    });
                };

                Uplib.loading.show({
                    text: 'loading'
                });

                _getProfile(res.uid);
            })
            .catch((res) => {
                Uplib.loading.hide();
                if (res && res.code) {
                    if (res.code === 'E000002' || res.code === 'E000003') {
                        if (platform === 'wechat') {
                            sns.jumpToSNS(platform, 'snsapi_userinfo');
                        } else if (platform === 'weibo') {
                            sns.jumpToSNS(platform);
                        } else if (platform === 'facebook') {
                            location.reload();
                        } else {
                            Uplib.notification.simple('system error');
                        }

                    } else if (res.code === 'E000001' || res.code === 'E000004') {
                        $(document.body).empty();
                        Uplib.notification.simple('system error', 100 * 1000);
                    } else if (res.code === 'E000005') {
                        $(document.body).empty();
                        Uplib.notification.simple('device forbidden', 100 * 1000);
                    }
                    return;
                }
                Uplib.notification.simple('system error');
            });
    },

    getDefaultCountryCode() {
        let systemLanguage = UpSDK.config.systemLanguage;

        return systemLanguage.split('-')[1].toUpperCase();
    },

    setProfile(userData) {
        let countryCode = this.getDefaultCountryCode();

        let setProfileCount = 0;

        let _setProfile = () => {
            let profileset = new ProfileSet({
                countryCode: countryCode
            });

            profileset.promise.then(
                (data) => {
                    userData.countryCode = countryCode;
                    UpSDK.writeLoginInfo(userData);
                    Uplib.loading.hide();
                    this.back();
                },
                function () {
                    ++setProfileCount;

                    if (setProfileCount > 3) {
                        Uplib.loading.hide();
                        Uplib.notification.simple('Fail to set your country / region', 100 * 1000);
                    } else {
                        _setProfile(countryCode);
                    }
                }
            );
        };

        _setProfile();
    },

    back() {
        UpSDK.emit('getUserSuccess', UpSDK.getUserInfo());
    }
};

export default token;



// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/token.js